import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { useResizer } from './useResizer';

export const VideoWrapper = ({ children }: React.PropsWithChildren) => {
  const { sizeRef, size } = useResizer();
  return (
    <Box
      ref={sizeRef}
      width="100%"
      flex="1 1 auto"
      justifyContent="center"
      alignItems="center"
      mb={3}
    >
      <div
        style={{
          position: 'relative',
          width: size.width,
          height: size.height,
        }}
      >
        {children}
      </div>
    </Box>
  );
};
